import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/HomePage/HomePage";
import AccountDetailPage from "../pages/AccountDetail/AccountDetailPage";
import CompletedPage from "../pages/CompletedPage/CompletedPage";
import TokenFailPage from "../pages/TokenFailPage/TokenFailPage";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authProvider";



const ProtectedComponent = ({ children }) => {
  const { instance } = useMsal();

  // Auto-redirect to Microsoft login when not authenticated
  useEffect(() => {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) {
      instance.loginRedirect(loginRequest);
    }
  }, [instance]);

  return (
    <AuthenticatedTemplate>
      {children}
    </AuthenticatedTemplate>
  );
};

const Main = () => (
  <div>
    <main>
      <Routes> 

          <Route path="/tokenfail" element={
            <ProtectedComponent>
              <TokenFailPage />
            </ProtectedComponent>
          } />

          <Route path="/complete" element={
            <ProtectedComponent>
              <CompletedPage />
            </ProtectedComponent>
          } /> 

          <Route path="/requests/:id" element={
            <ProtectedComponent>
              <AccountDetailPage />
            </ProtectedComponent>
          } />

          <Route path="/requests" element={
            <ProtectedComponent>
              <Home />
            </ProtectedComponent>
          } /> 
          
          <Route path="/" element={<Navigate to="/requests" replace={true} />} />     
      </Routes>       
    </main>
  </div>
);

export default Main;
